import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Waveform, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("admin@relay.app");
  const [password, setPassword] = useState("dub12345");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email.trim(), password);
    setBusy(false);
    if (ok) nav("/");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-border bg-[#18181B]">
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 bg-primary flex items-center justify-center"><Waveform weight="bold" className="text-black" size={20} /></div>
          <span className="font-mono font-extrabold tracking-tighter">RELAY<span className="text-primary">/</span>AI</span>
        </div>
        <div>
          <div className="overline mb-4">internal orchestration lab</div>
          <h1 className="font-mono font-extrabold tracking-tighter text-4xl leading-tight mb-6">
            Chain the models.<br />Beat any single tool.
          </h1>
          <p className="text-muted-foreground text-sm max-w-md leading-relaxed">
            Two pipelines, one thesis: orchestrate best-in-class models instead of one monolith.
            <span className="text-foreground"> Audio Dub</span> translates & re-voices any clip across languages;
            <span className="text-foreground"> Video Studio</span> turns raw footage — or just a script — into a finished 9:16 reel.
            Score every result blind against a baseline, track cost per finished minute, and decide with data.
          </p>
        </div>
        <div className="grid grid-cols-3 gap-px bg-border border border-border">
          {[["2 tools", "audio dub · video studio"], ["6+ models", "chained per run"], ["blind A/B", "cost-gated thesis"]].map(([a, b]) => (
            <div key={b} className="bg-[#18181B] p-4">
              <div className="font-mono font-bold text-primary text-lg">{a}</div>
              <div className="overline mt-1" style={{ fontSize: "0.5rem" }}>{b}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="overline mb-2">restricted · internal team</div>
          <h2 className="font-mono font-bold text-2xl tracking-tighter mb-8">Sign in</h2>
          <label className="overline block mb-2">email</label>
          <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
            className="w-full bg-[#18181B] border border-border px-4 py-3 font-mono text-sm mb-5 focus:border-primary outline-none transition-colors" />
          <label className="overline block mb-2">password</label>
          <input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
            className="w-full bg-[#18181B] border border-border px-4 py-3 font-mono text-sm mb-6 focus:border-primary outline-none transition-colors" />
          {error && <div data-testid="login-error" className="text-destructive text-xs font-mono mb-4">{error}</div>}
          <button data-testid="login-submit" disabled={busy} type="submit"
            className="w-full bg-primary text-black font-mono font-bold py-3 flex items-center justify-center gap-2 hover:bg-[#FF7733] hover:-translate-y-[1px] transition-transform disabled:opacity-50">
            {busy ? "authenticating…" : <>enter lab <ArrowRight weight="bold" size={16} /></>}
          </button>
          <div className="mt-6 text-xs text-muted-foreground font-mono leading-relaxed">
            seeded: admin@relay.app · reviewer1@ · reviewer2@<br />password: dub12345
          </div>
        </form>
      </div>
    </div>
  );
}
